import { render, staticRenderFns } from "./component.vue?vue&type=template&id=039d10ea&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.vue?vue&type=style&index=0&id=039d10ea&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d10ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('039d10ea')) {
      api.createRecord('039d10ea', component.options)
    } else {
      api.reload('039d10ea', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=039d10ea&scoped=true", function () {
      api.rerender('039d10ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/ComponentDetails/components/component.vue"
export default component.exports